import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackerManagementExperience.list'

const TrackerManagementTrackerListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackerManagementTrackerListSlice
